import { useEffect, useState } from "react";

import { getEntitiesByEmail } from "../services/svt/svt-user";

const useGetEntitiesData = (activeModule, roleName) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const result = await getEntitiesByEmail();
                setData(result.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (activeModule && roleName) {
            activeModule === "SELFVERIFICATION" &&
                roleName.includes("PIC") &&
                fetchData();
        }
    }, [activeModule, roleName]);

    return [data, loading];
};

export default useGetEntitiesData;
